module.exports = __webpack_public_path__ + "img/arrow.645712d0.svg";